<template>
  <div class="gmb-attribute-chip" @click="toggleValue">
    <v-chip color="primary" outlined v-if="value && !deleteMode">
      <v-icon left>
        icon-check
      </v-icon>
      {{ name }}
    </v-chip>
    <v-chip outlined v-else-if="value && deleteMode" class="danger">
      <v-icon left>
        icon-trash
      </v-icon>
      {{ name }}
    </v-chip>
    <v-chip v-else-if="value === false">
      <v-icon left>
        mdi-cancel
      </v-icon>
      {{ name }}
    </v-chip>
    <v-chip outlined v-else>
      <v-icon left>
        icon-plus
      </v-icon>
      {{ name }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "GmbAttributeChip",
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [Boolean]
    },
    booleanOnly: {
      type: [Boolean],
      default: () => false
    },
    toggleOnly: {
      type: Boolean,
      default: false
    },
    deleteMode: {
      type: Boolean,
      default: () => false
    }
  },
  mounted() {},
  methods: {
    toggleValue() {
      let newValue = true;
      if (this.deleteMode) {
        if (this.value) {
          newValue = null;
        }
      } else {
        if (this.value === true && this.toggleOnly) {
          newValue = null;
        } else if (this.value === true) {
          newValue = false;
        } else if (this.value === false && this.booleanOnly) {
          newValue = true;
        } else if (this.value === false) {
          newValue = null;
        }
      }

      this.$emit("input", newValue);
    }
  }
};
</script>
<style lang="scss" scoped>
.gmb-attribute-chip {
  display: inline-flex;
  user-select: none;

  .v-chip {
    cursor: pointer;
    user-select: none;
    border: 1px solid rgba(0, 0, 0, 0.05);
    filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.05));
    height: unset;
    min-height: 40px;
    border-radius: 20px;
    @include font-size(14px);
    font-weight: 400;
    margin: $spacing / 2 $spacing $spacing / 2 0;
    padding: 5px $spacing * 2;
    max-width: 100%;
    white-space: normal;

    &.v-chip--outlined.v-chip--no-color {
      background: $light !important;

      &.danger {
        color: $attribute-remove-color !important;
        background: $attribute-remove-bg-color !important;
      }
    }

    &.v-chip--outlined.primary {
      background: $attribute-active-bg-color !important;
    }

    &:not(.v-chip--active) {
      background: $attribute-inactive-bg-color;
    }

    &:hover::before {
      opacity: 0;
    }
  }
}
</style>
